import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { FirstAidForm } from './first-aid.interface';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FirstAidService {
  private apiUrl = `${environment.apiConfig.uri}/first-aid`;

  constructor(private http: HttpClient) { }

  createFirstAid(newFirstAid: FirstAidForm): Observable<any> {
    return this.http.post(this.apiUrl, {
      userEmail: newFirstAid.userEmail,
      dateTimeOfFirstAid: newFirstAid.dateTimeOfFirstAid,
      incidentLocation: newFirstAid.incidentLocation,
      firstAidResponder: newFirstAid.firstAidResponder,
      firstAidProvidedTo: newFirstAid.firstAidProvidedTo,
      typeOfFirstAid: newFirstAid.typeOfFirstAid,
      whyFirstAidNecessary: newFirstAid.whyFirstAidNecessary,
      dateReportSubmitted: newFirstAid.dateReportSubmitted,
      reporterSignature: newFirstAid.reporterSignature,
      reporterCompleted: newFirstAid.reporterCompleted,
      safetyDirectorSignature: newFirstAid.safetyDirectorSignature,
      safetyDirectorCompleted: newFirstAid.safetyDirectorCompleted
    });
  }
    
  getForm(formId: string): Observable<any> {
    const url = `${this.apiUrl}/${formId}`;
    return this.http.get(url)
  }

  updateSection2(formId: string, section2Data: FirstAidForm[]): Observable<any> {
    const url = `${this.apiUrl}/${formId}/section2`;
    return this.http.put(url, { section2Data });
  }
}
